import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/celebrities/CelebritiesContent.tsx");
